import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';

const RestChangelogPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  // Para changelog público (não requer autenticação)
  const emp = '0';
  const uid = '0';

  switch (caminho) {
    case 'obter-changelog':
      return new Promise(function (resolve, reject) {
        const limite = Arr_.limite || null;
        
        try {
          const dataPost = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({limite}))];
          
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrlPbl_.class.php`,
            type: 'Get',
            dataType: 'json',
            data: {
              pp: base64_encode('changelog'),
              ll: base64_encode('obter-changelog'),
              dd: base64_encode(JSON.stringify(dataPost)),
            },
            success: function (data) {
              try {
                const decoded = JSON.parse(base64_decode(data));
                resolve([200, decoded]);
              } catch (e) {
                console.error('Erro ao decodificar resposta:', e, data);
                reject([400, {success: false, error: 'Erro ao decodificar resposta'}]);
              }
            },
            error: function (xhr, status, error) {
              console.error('Erro AJAX:', {xhr, status, error});
              reject([400, {success: false, error: 'Erro ao carregar changelog'}]);
            },
          });
        } catch (err) {
          console.error('Erro no RestChangelogPost:', err);
          reject([500, {success: false, error: 'Server Error: ' + err.message}]);
        }
      });
    
    default:
      return new Promise((resolve) => resolve([404, {success: false, error: 'Rota não encontrada'}]));
  }
};

export default RestChangelogPost;
